export const GET_WORKOUT_PLAN_LIBRARY = 'workoutPlan/GET_WORKOUT_PLAN_LIBRARY';
export const GET_WORKOUT_PLAN_LIBRARY_SUCCESS = 'workoutPlan/GET_WORKOUT_PLAN_LIBRARY_SUCCESS';
export const GET_WORKOUT_PLAN_LIBRARY_ERROR = 'workoutPlan/GET_WORKOUT_PLAN_LIBRARY_ERROR';

export const GET_USER_WORKOUT_PLANS = 'workoutPlan/GET_USER_WORKOUT_PLANS';
export const GET_USER_WORKOUT_PLANS_SUCCESS = 'workoutPlan/GET_USER_WORKOUT_PLANS_SUCCESS';
export const GET_USER_WORKOUT_PLANS_ERROR = 'workoutPlan/GET_USER_WORKOUT_PLANS_ERROR';